
import markdown from 'markdown-it';
import generateMetaData from '~/features/metaDataGenerator';

export default {
    props: {
        body: String,
        meta: Object,
        url: String,
    },
    name: 'Static',
    computed: {
        parsedContent() {
            const md = markdown({
                html: true,
                linkify: true,
                typographer: true,
            });

            return md.render(this.body);
        },
        showRecordingWidget() {
            return this.$config.webAppDomain !== 'beams.fm';
        },
    },
    head() {
        return generateMetaData({
            url: this.$store.getters['app/getFullyQualifiedURL'],
            title: this.meta.title,
            description: this.meta.description,
        });
    },
};
